import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7ebe7e2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-absolute logo-gift-card bg-white rounded-circle" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "d-flex flex-row position-absolute bottom-0 w-100 gift-card-gradient pt-5 px-2 pb-2" }
const _hoisted_5 = { class: "d-flex flex-column px-2 text-white" }
const _hoisted_6 = { class: "h4 mb-1" }
const _hoisted_7 = { class: "small fw-medium mb-2" }
const _hoisted_8 = { class: "ms-auto rounded-pill bg-white mt-auto mb-2 me-2 px-1" }
const _hoisted_9 = { class: "fw-bold text-primary fs-6" }

import { PropType, computed, defineComponent } from 'vue';

import AffiliateCampaign from '@/tmp/src/entities/affiliate/affiliateCampaign';
import useAffiliateCustomerStore from '@/stores/affiliate';

import { useIonRouter } from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftRowSelfRecommandation',
  props: {
  gift: {
    type: Object as PropType<AffiliateCampaign>,
    required: true,
  },
},
  setup(__props) {

const router = useIonRouter();
const props = __props;

function goToGiftPreview() {
  router.push(`/gifts/preview/${props.gift.id}`);
}

const domains = {
  development: 'http://localhost:1337',
  staging: 'https://api.staging.petitcitron.fr',
  production: 'https://api.petitcitron.fr',
};
const baseDomain = domains[import.meta.env.MODE];

function getPictureUrl() {
  if (!props.gift.picture) {
    return 'https://ionicframework.com/docs/img/demos/card-media.png';
  }
  return `${baseDomain}${props.gift.portrait}`;
}
const affiliateCustomerStore = useAffiliateCustomerStore();
const logoUrl: string | null = affiliateCustomerStore
  .getAffilitatePictureByCampaignId(props.gift.id);
const getLogoUrl = computed(() => {
  if (logoUrl === null) {
    return 'https://ionicframework.com/docs/img/demos/card-media.png';
  }
  if (import.meta.env.MODE === 'development') {
    return `http://localhost:1337${logoUrl}`;
  }
  return `https://api.petitcitron.fr${logoUrl}`;
});
defineComponent({ name: 'GiftRowSelfRecommandation' });

return (_ctx: any,_cache: any) => {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_component_ion_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_text, { class: "h4" }, {
            default: _withCtx(() => [
              _createTextVNode(" 😍 On recommande... ")
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, {
            button: true,
            class: "rounded position-relative ion-card-background",
            onClick: goToGiftPreview
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("img", {
                  src: getLogoUrl.value,
                  alt: "",
                  width: "55",
                  class: "img-fluid rounded-circle"
                }, null, 8, _hoisted_2)
              ]),
              _createElementVNode("img", {
                alt: "Silhouette of mountains",
                src: getPictureUrl(),
                class: "img-fluid"
              }, null, 8, _hoisted_3),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(__props.gift.title), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(__props.gift.offer), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(__props.gift.cost) + " 🍋 ", 1)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})